import React, { useEffect } from 'react';
import { Box, Container, Typography } from '@mui/material';
import thankYouDefaultImage from '../../assets/images/thank-you.png';
import {
  getSafeThankYouRedirectUrl,
  getThankYouSettings
} from '../../utils/thankYouSettings';

const REDIRECT_DELAY_MS = 3000;
const redirectToUrl = (url) => window.location.assign(url);

const ThankYouScreen = ({
  formSettings,
  submissionSucceeded = true,
  onRedirect = redirectToUrl
}) => {
  const thankYouSettings = getThankYouSettings(formSettings);
  const redirectUrl = getSafeThankYouRedirectUrl(thankYouSettings.redirectUrl);

  useEffect(() => {
    if (!submissionSucceeded || !redirectUrl) return undefined;

    const redirectTimeout = window.setTimeout(
      () => onRedirect(redirectUrl),
      REDIRECT_DELAY_MS
    );
    return () => window.clearTimeout(redirectTimeout);
  }, [onRedirect, redirectUrl, submissionSucceeded]);

  return (
    <Box sx={{ position: 'relative', minHeight: '100vh' }}>
      <Container sx={{
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        width: '100%',
        display: 'flex',
        flexDirection: 'column'
      }}>
        <Box
          sx={{
            textAlign: 'center',
            p: 4,
            maxWidth: '600px',
            margin: 'auto auto'
          }}
        >
          <img
            src={thankYouSettings.image || thankYouDefaultImage}
            alt="Thank You"
            style={{
              maxWidth: '100%',
              height: 'auto',
              marginBottom: '2rem'
            }}
          />
          <Typography
            variant="h4"
            component="div"
            sx={{ whiteSpace: 'pre-line', mb: 2 }}
          >
            {thankYouSettings.title}
          </Typography>
          <Typography
            variant="body1"
            component="div"
            sx={{ whiteSpace: 'pre-line' }}
          >
            {thankYouSettings.message}
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default ThankYouScreen;
